import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSummary = createCustomElementWrapper('kat-summary', 'KatSummary', {}, {}, [
    'actions',
]);
